import { render, staticRenderFns } from "./ProductSidebar.vue?vue&type=template&id=78d47b6d&scoped=true"
import script from "./ProductSidebar.vue?vue&type=script&lang=js"
export * from "./ProductSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProductSidebar.vue?vue&type=style&index=0&id=78d47b6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d47b6d",
  null
  
)

export default component.exports